module.exports = __webpack_public_path__ + "images/cat_coffee.jpg";